import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MuxPlayer from '@mux/mux-player-react';
import { StyledImg } from '../style';
import Image from '../../../core/Image';
import Galleries from '../../../core/Gallery';
import { videoUrl } from '../../../../utils/resources';

const Video = ({ src }) => {
  const [playBackId, setPlayBackId] = useState('');
  const [posterImg, setPosterImg] = useState('');

  useEffect(() => {
    videoUrl(src?.id).then(data => {
      setPlayBackId(data.muxPlaybackID);
      setPosterImg(data.poster.baseLocationPath);
    });
  }, []);
  return (
    <div
      style={{
        height: 'fit-content'
      }}
    >
      <MuxPlayer
        streamType="on-demand"
        playbackId={playBackId}
        poster={posterImg}
      />
    </div>
  );
};
const Gallery = ({ home = false, ...props }) => (
  <Galleries home={home} {...props} />
);
const ImageContainer = ({
  src,
  extFormat,
  defaultCrop,
  onClickContent,
  home
}) => (
  <StyledImg>
    <Image
      path={src}
      extFormat={extFormat}
      onClick={onClickContent}
      defaultCrop={defaultCrop}
      home={home}
    />
  </StyledImg>
);

const CropType = PropTypes.shape({
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
});

ImageContainer.propTypes = {
  src: PropTypes.string,
  defaultCrop: CropType,
  home: PropTypes.bool,
  extFormat: PropTypes.string
};

export { ImageContainer as Image, Video, Gallery };
